(() => {
  const DEBUG = true;
  const log = (...args) => DEBUG && console.log("[Paas+Easify]", ...args);

  let cachedInitials = "";
  let cachedColour = "";

  const initialsSelectors = [
    `input[name="properties[My Initials]"]`,
    `input[type="text"][aria-label="My Initials"]`,
    `input.tpo_option-input[type="text"][aria-label*="initial" i]`,
    `.tpo_option-input-wrapper input[type="text"]`,
  ];

  const colourCheckedSelector = [
    `input[type="radio"][name$=",Embroid_Colour"]:checked`,
    `input[type="radio"][name$=",Initial Colour"]:checked`,
  ].join(", ");

  const colourRadioSelector = [
    `input[type="radio"][name$=",Embroid_Colour"]`,
    `input[type="radio"][name$=",Initial Colour"]`,
  ].join(", ");

  const isCartAddUrl = (url) => {
    const u = String(url || "");
    try {
      const parsed = new URL(u, window.location.origin);
      return /\/cart\/add(\.js)?$/.test(parsed.pathname);
    } catch {
      return /\/cart\/add(\.js)?(\?|$)/.test(u);
    }
  };

  const normalizeColour = (value) => {
    const v = (value || "").trim();
    if (!v) return "";
    const l = v.toLowerCase();
    if (l.includes("gold")) return "Gold";
    if (l.includes("silver")) return "Silver";
    return v;
  };

  const findInitialsInput = () => {
    const nodes = [];
    for (const sel of initialsSelectors) {
      const found = document.querySelectorAll(sel);
      if (found?.length) nodes.push(...found);
    }
    const withValue = nodes.find((el) => (el.value || "").trim().length);
    return withValue || nodes[0] || null;
  };

  const readInitials = () => {
    const el = findInitialsInput();
    const value = (el?.value || "").trim();
    return value || cachedInitials;
  };

  const readColour = () => {
    const checked = document.querySelector(colourCheckedSelector);
    const value = normalizeColour(checked?.value);
    return value || cachedColour;
  };

  const getProps = () => {
    const initials = readInitials();
    const colour = readColour();

    const props = {};
    if (initials) props["My Initials"] = initials;
    if (colour) props["Embroid Colour"] = colour; // ✅ fixed key

    if (DEBUG) log("props", props);
    return props;
  };

  const mergeBody = (body, props) => {
    if (!props || !Object.keys(props).length || body == null) return body;

    if (typeof body === "string") {
      const data = JSON.parse(body);

      if (Array.isArray(data.items)) {
        data.items = data.items.map((item) => ({
          ...item,
          properties: { ...(item.properties || {}), ...props },
        }));
      } else {
        data.properties = { ...(data.properties || {}), ...props };
      }

      return JSON.stringify(data);
    }

    if (body instanceof FormData || body instanceof URLSearchParams) {
      Object.entries(props).forEach(([k, v]) => body.set(`properties[${k}]`, v));
      return body;
    }

    return body;
  };

  document.addEventListener("input", (e) => {
    const t = e.target;
    if (!t || t.tagName !== "INPUT" || t.type !== "text") return;

    const aria = (t.getAttribute("aria-label") || "").toLowerCase();
    const name = (t.getAttribute("name") || "").toLowerCase();

    if (
      aria.includes("initial") ||
      name.includes("properties[my initials]") ||
      name.includes("my initials")
    ) {
      cachedInitials = (t.value || "").trim();
      if (DEBUG) log("cachedInitials", cachedInitials);
    }
  });

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t || !t.matches?.(colourRadioSelector)) return;

    if (t.checked) {
      cachedColour = normalizeColour(t.value || "");
      if (DEBUG) log("cachedColour", cachedColour);
    }
  });

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input?.url || "";
    if (!isCartAddUrl(url)) return nativeFetch.apply(this, arguments);

    try {
      init = init || {};
      const props = getProps();
      init.body = mergeBody(init.body, props);
      if (DEBUG) log("intercept fetch cart/add", url, props);
    } catch (err) {
      console.warn("[Paas+Easify] fetch merge failed:", err);
    }

    return nativeFetch.call(this, input, init);
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__url = String(url || "");
    this.__isCartAdd = isCartAddUrl(this.__url);
    return xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    // ✅ move this outside so it logs everything when DEBUG=true
    if (DEBUG) console.log("[Paas+Easify] XHR ->", this.__url || "(no url)");

    if (!this.__isCartAdd) return xhrSend.apply(this, arguments);

    try {
      const props = getProps();
      body = mergeBody(body, props);
      if (DEBUG) log("intercept xhr cart/add", this.__url, props);
    } catch (err) {
      console.warn("[Paas+Easify] xhr merge failed:", err);
    }

    return xhrSend.call(this, body);
  };
})();
